<template>
  <div>
    <div class="upload">
      <p class="theme-color">{{ idType }}</p>
      <div class="image-id">
        <input type="file" accept="image/*" class="image" id="uploadImage1" style="visibility: hidden"
          @change="selectFileImage1($event)" />
        <label for="uploadImage1">
          <van-image class="showimage-id" :src="pic1 || tipPic[0]"></van-image>
        </label>
        <div
          v-if="pic1"
          style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
          @click="handleDelete('id_photo_0', 'pic1')"
          block
          size="small"
        >
          <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
        </div>
      </div>
    </div>
    <div class="upload" v-if="idType !== '护照'">
      <div class="image-id">
        <input type="file" accept="image/*" class="image" id="uploadImage2" style="visibility: hidden"
          @change="selectFileImage2($event)" />
        <label for="uploadImage2">
          <van-image class="showimage-id" :src="pic2 || tipPic[1]"></van-image>
        </label>
        <div
          v-if="pic2"
          style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
          @click="handleDelete('id_photo_1', 'pic2')"
          block
          size="small"
        >
          <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
        </div>
      </div>
    </div>
    <div class="upload" v-if="tipPic[1] === ot3">
      <div class="image-id">
        <input type="file" accept="image/*" class="image" id="uploadImage2" style="visibility: hidden"
          @change="selectFileImage2($event)" />
        <label for="uploadImage2">
          <van-image class="showimage-id" :src="pic3 || tipPic[1]"></van-image>
        </label>
        <div
          v-if="pic3"
          style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
          @click="handleDelete('id_photo_1', 'pic3')"
          block
          size="small"
        >
          <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
        </div>
      </div>
    </div>
    <div class="upload" v-if="tipPic[2] === ot3">
      <div class="image-id">
        <input type="file" accept="image/*" class="image" id="uploadImage3" style="visibility: hidden"
          @change="selectFileImage3($event)" />
        <label for="uploadImage3">
          <van-image class="showimage-id" :src="pic3 || tipPic[2]"></van-image>
        </label>
        <div
          v-if="pic3"
          style="z-index: 99;position: absolute; top: 0px; right: 12px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
          @click="handleDelete('id_photo_2', 'pic3')"
          block
          size="small"
        >
          <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
        </div>
      </div>
    </div>
    <div class="upload-tip theme-color">点击图片上传或更新</div>
    <div class="common-id-tip theme-color">
      <span>提示：<br /></span>
      <span>1.拍摄时请确保证件平放，光线充足。<br /></span>
      <span>2.确保文字清晰、边框完整。<br /></span>
      <span v-if="idType === '其它'">3.至少需要上传一张有效照片。<br /></span>
      <span v-if="idType === '身份证'">3.示例（点击可查看）：<span class="link"
          @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_2ID_01.jpg')">
          身份证人像面
        </span>、<span class="link"
          @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_2ID_02.jpg')">
          身份证非人像面
        </span>。<br /></span>
      <span v-if="idType === '护照'">3.示例（点击可查看）：<span class="link"
          @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_2passport.jpg')">
          护照
        </span>。<br /></span>
      <span v-if="idType === '其它'">4.示例（点击可查看）：<span class="link"
          @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_3other_01.jpg')">
          其它证件人像面
        </span>、<span class="link"
          @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_3other_02.jpg')">
          其它证件非人像面
        </span>。<br /></span>
    </div>

  </div>
</template>

<script>
import {
  Uploader, Image, ImagePreview,
} from 'vant';
import { useStore } from 'vuex';
import { onMounted, ref } from 'vue';
import httpApi from '../../utils/httpApi';
import uploadImage from './uploadImage';

const id1 = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/2-1_ID1.png';
const id2 = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/2-2_ID2.png';
const pa1 = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/2-3_passport.png';
const ot1 = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/2-4_other1.png';
const ot2 = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/2-4_other2.png';
const ot3 = 'data:image/png;base64,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';
export default {
  name: 'Home',
  components: {
    [Uploader.name]: Uploader,
    [Image.name]: Image,
  },
  data() {
    return {
      type: '',
      fileList: [],
      ot3,
    };
  },
  methods: {
    handleDelete(type, key) {
      httpApi.deleteFile({ type }).then((res) => {
        if (res.code === 200) {
          this.$toast('删除成功');
          this[key] = '';
        } else {
          this.$toast(res.msg || '删除失败、请重试');
        }
      });
    },
    async selectFileImage1(event) {
      const file = event.target.files[0];
      uploadImage(file, 'id_photo_0', (photo) => {
        this.pic1 = photo;
      });
    },
    async selectFileImage2(event) {
      const file = event.target.files[0];
      uploadImage(file, 'id_photo_1', (photo) => {
        this.pic2 = photo;
      });
    },
    async selectFileImage3(event) {
      const file = event.target.files[0];
      uploadImage(file, 'id_photo_2', (photo) => {
        this.pic3 = photo;
      });
    },
    showPreview(key) {
      ImagePreview([key]);
    },
    link(name) {
      this.$router.push({ name });
    },
    next() {
      this.$router.push({ path: '/info2' });
    },
    before() {
      this.$router.go(-1);
    },
  },
  setup() {
    const idType = ref('');
    const pic1 = ref('');
    const pic2 = ref('');
    const pic3 = ref('');
    const tipPic = ref([]);
    const fileList1 = ref([]);
    const fileList2 = ref([]);
    onMounted(async () => {
      const store = useStore();
      store.commit('setTitleValue', '上传资料');
      store.commit('setStepsShow', false);
      const result = await httpApi.getUploadImgesStatus();
      if (!result) return;
      idType.value = result.data.type;
      const res1 = await httpApi.getUploadImgesByType({ type: 'id_photo_0' });
      if (res1) pic1.value = res1.data.value;
      const res2 = await httpApi.getUploadImgesByType({ type: 'id_photo_1' });
      if (res2) pic2.value = res2.data.value;
      const res3 = await httpApi.getUploadImgesByType({ type: 'id_photo_2' });
      if (res3) pic3.value = res3.data.value;
      if (idType.value.endsWith('身份证')) {
        tipPic.value[0] = id1;
        tipPic.value[1] = id2;
        tipPic.value[2] = ot3;
      } else if (idType.value === '护照') {
        tipPic.value[0] = pa1;
        tipPic.value[1] = ot3;
        tipPic.value[2] = ot3;
      } else if (idType.value === '其它') {
        tipPic.value[0] = ot1;
        tipPic.value[1] = ot2;
        tipPic.value[2] = ot3;
      }
    });
    console.log(tipPic);
    return {
      idType,
      tipPic,
      pic1,
      pic2,
      pic3,
      fileList1,
      fileList2,
    };
  },
};
</script>

<style lang="less">
.image-id {
  width: 300px;
  height: 200px;
  margin: auto;
  position: relative;
}

.showimage-id {
  position: absolute;
  width: 300px;
  height: 200px;
  top: 0;
  left: 0;
}

.upload-tip {
  text-align: center !important;
  color: @font-color-2;
  margin-top: @space-2;
}

.common-id-tip {
  margin-top: 10px;
  color: @font-color-1;
  text-align: left;
  padding-left: @space-0;
  padding-right: @space-0;
}
</style>
